import React, { useState, useEffect, useCallback, useRef } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { TransationColumnDefs } from "../columns/PerformanceColumns";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
export interface IOlympicData {
  symbol: string;
  transactionDate: any;
  transactionCode: any;
  amount: number;
  quantity: number;
  price: number;
  notes: any;
}

interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

export const Transactions = () => {
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const [TransationDetails, setTransationDetails] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("Transactions", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setTransationDetails(response);
        setSectorCount(response);
      });
  }, []);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setTransationDetails(
      sectorCount.slice(pageNumbers * 50 - 50, pageNumbers * 50)
    );
    setSectorCurrentPage(pageNumbers);
  };

  function onGridReady(params: any) {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }
  const handleChange = (e: any) => {
    gridApi.setQuickFilter(e.target.value);
  };
  const onBtExportMain = useCallback(() => {
    dataGridRefMain.current!.api.exportDataAsExcel();
  }, []);

  const exportPDFData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Transactions Details";
    const headers = [
      [
        "symbol",
        "transactionDate",
        "transactionCode",
        "amount",
        "quantity",
        "price",
        "notes",
      ],
    ];

    const data = TransationDetails.map((e: any) => [
      e.symbol,
      e.transactionDate,
      e.transactionCode,
      e.amount,
      e.quantity,
      e.price,
      e.notes,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("TransactionsDetails.pdf");
  };

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Transactions</h1>
      </div>
      <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
        <div className="card w-100">
          <div className="card-header">
            <h5 className="card-title d-inline-block">Transactions Details</h5>
            <div className="d-inline-block col-sm-3 float-end">
              <input
                type="text"
                id="filter-text-box"
                placeholder="Search..."
                onInput={handleChange}
                className="form-control"
              />
              <div className="col-sm-12 my-3 text-end">
                <i
                  className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                  style={{ fontSize: "16px" }}
                  onClick={onBtExportMain}
                ></i>
                <i
                  className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                  onClick={() => exportPDFData()}
                  style={{ fontSize: "16px" }}
                ></i>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="chart chart-xs px-2">
              <div className="chartjs-size-monitor">
                <div className="chartjs-size-monitor-shrink">
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "500px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                      ref={dataGridRefMain}
                      onGridReady={onGridReady}
                      rowData={TransationDetails}
                      columnDefs={TransationColumnDefs}
                      rowHeight={40}
                      pagination={true}
                      paginationPageSize={40}
                      //paginationAutoPageSize={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
